import { Box, Button, Card, CardContent, CardMedia, Container, Grid2 as Grid, Typography } from '@mui/material'
import * as React from 'react'
import { useNavigate } from 'react-router'

import PrivacyPolicyLink from '../components/common/PrivacyPolicyLink'
import SEOHead from '../components/common/SEOHead'

export default function Home() {
  const navigate = useNavigate()

  const cards = [
    {
      title: 'Private Lessons',
      description: 'Book one-on-one sessions with professional instructors to improve your skiing or snowboarding skills.',
      image: 'https://images.pexels.com/photos/848612/pexels-photo-848612.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      path: '/instructors',
      buttonText: 'View Instructors',
    },
    {
      title: 'Group Sessions',
      description: 'Join our group sessions to learn and improve with like-minded peers.',
      image: 'https://images.pexels.com/photos/376697/pexels-photo-376697.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      path: '/events/sessions',
      buttonText: 'View Sessions',
    },
    {
      title: 'Trips',
      description: 'Explore our upcoming trips to various ski resorts.',
      image: 'https://images.pexels.com/photos/258045/pexels-photo-258045.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      path: '/events/trips',
      buttonText: 'View Trips',
    },
  ]

  return (
    <>
      <SEOHead pageName="HOME" url="https://bookingonsnow.com/" structuredDataType="SportsActivityLocation" />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* <SnowEffect /> */}
        <Typography variant="h3" gutterBottom>
          Welcome to
        </Typography>
        <Typography
          variant="h3"
          gutterBottom
          sx={{
            mb: 2,
            fontWeight: 800,
            letterSpacing: '0.02em',
            fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
            position: 'relative',
          }}
        >
          BookingOnSnow
        </Typography>

        <Typography variant="p" color="text.secondary" paragraph sx={{ mb: 4, fontSize: '1.2rem', lineHeight: 1.6 }}>
          Connect with top-rated ski and snowboard instructors from{' '}
          <Typography
            variant="h5"
            color="primary.main"
            fontWeight="bold"
            sx={{
              px: 1,
            }}
            component="a"
            href="https://keshikadventures.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ottawa Chinese Ski Club
          </Typography>
          . Book your personalized lesson in minutes and start your snow adventure today!
        </Typography>

        <Grid container spacing={4} alignItems="stretch" justifyContent="center">
          {cards.map((card, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Card
                onClick={() => navigate(card.path)}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: (theme) => theme.shadows[8],
                    '& .MuiCardMedia-root': {
                      transform: 'scale(1.05)',
                      transition: 'transform 0.3s ease-in-out',
                    },
                  },
                }}
              >
                <Box sx={{ overflow: 'hidden' }}>
                  <CardMedia
                    component="img"
                    height="300"
                    image={card.image}
                    alt={card.title}
                    sx={{
                      transition: 'transform 0.3s ease-in-out',
                    }}
                  />
                </Box>
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', p: 3 }}>
                  <Box>
                    <Typography variant="h5" gutterBottom>
                      {card.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" paragraph>
                      {card.description}
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={(e) => {
                      e.stopPropagation()
                      navigate(card.path)
                    }}
                  >
                    {card.buttonText}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <PrivacyPolicyLink />
      </Container>
    </>
  )
}
